import Box from '@mui/material/Box';

// Small category label used above section headings
const Eyebrow = ({ children, white = false, sx = {} }) => (
  <Box
    component="span"
    sx={{
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.22em',
      textTransform: 'uppercase',
      color: white ? 'var(--sage-l)' : 'var(--sage)',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1,
      '&::before': {
        content: '""',
        width: 24,
        height: '1.5px',
        background: white ? 'var(--sage-l)' : 'var(--sage)',
        borderRadius: 1,
        flexShrink: 0,
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default Eyebrow;
